export const HELP_MENU_CODE = 'HELP';
